import { render, staticRenderFns } from "./changeCaseList.vue?vue&type=template&id=4b6e44b1&scoped=true&"
import script from "./changeCaseList.vue?vue&type=script&lang=js&"
export * from "./changeCaseList.vue?vue&type=script&lang=js&"
import style0 from "./changeCaseList.vue?vue&type=style&index=0&id=4b6e44b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6e44b1",
  null
  
)

export default component.exports